/**
################################
 * Component food_menu_list
 * Built with Maciste / Version 2.0
################################
*/


'use strict';

jQuery(document).ready(function () {
    // console.log('food_menu_list');
});

